goog.provide("shadow.js.shim.module$$mui$material$Stack");
goog.provide("module$shadow_js_shim_module$$mui$material$Stack");
shadow.js.shim.module$$mui$material$Stack = shadow.js.nativeProvides["@mui/material/Stack"] = shadow$bridge("@mui/material/Stack");
module$shadow_js_shim_module$$mui$material$Stack.default = shadow.js.shim.module$$mui$material$Stack;
